import { logout as logoutReq } from "../services/apiV2";
import { resetUserState } from "../features/user/user.slice";
import { useCallback, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../store/hooks";
import { logoutExtension } from "../utils/extension";

export const useLogout = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const logout = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      await logoutReq();
      dispatch(resetUserState());
      logoutExtension(searchParams.get("from") === "extension");
      navigate("/login");
    } catch (e) {
      setError("Failed to logout");
    } finally {
      setLoading(false);
    }
  }, [dispatch, navigate]);

  return { logout, loading, error };
};
